export default "__VITE_ASSET__VHkrR$K___"